/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TimezoneMetadata } from './TimezoneMetadata';
import {
    TimezoneMetadataFromJSON,
    TimezoneMetadataFromJSONTyped,
    TimezoneMetadataToJSON,
    TimezoneMetadataToJSONTyped,
} from './TimezoneMetadata';

/**
 * 
 * @export
 * @interface ApproveResponse
 */
export interface ApproveResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ApproveResponse
     */
    success?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApproveResponse
     */
    message?: string;
    /**
     * 
     * @type {string}
     * @memberof ApproveResponse
     */
    candidateId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApproveResponse
     */
    goldenRecordId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApproveResponse
     */
    errorMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof ApproveResponse
     */
    userTimezone?: string;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof ApproveResponse
     */
    error?: string;
    /**
     * 
     * @type {TimezoneMetadata}
     * @memberof ApproveResponse
     */
    timezoneMetadata?: TimezoneMetadata;
}

/**
 * Check if a given object implements the ApproveResponse interface.
 */
export function instanceOfApproveResponse(value: object): value is ApproveResponse {
    return true;
}

export function ApproveResponseFromJSON(json: any): ApproveResponse {
    return ApproveResponseFromJSONTyped(json, false);
}

export function ApproveResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApproveResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'message': json['message'] == null ? undefined : json['message'],
        'candidateId': json['candidateId'] == null ? undefined : json['candidateId'],
        'goldenRecordId': json['goldenRecordId'] == null ? undefined : json['goldenRecordId'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
        'userTimezone': json['userTimezone'] == null ? undefined : json['userTimezone'],
        'error': json['error'] == null ? undefined : json['error'],
        'timezoneMetadata': json['timezone_metadata'] == null ? undefined : TimezoneMetadataFromJSON(json['timezone_metadata']),
    };
}

export function ApproveResponseToJSON(json: any): ApproveResponse {
    return ApproveResponseToJSONTyped(json, false);
}

export function ApproveResponseToJSONTyped(value?: ApproveResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
        'candidateId': value['candidateId'],
        'goldenRecordId': value['goldenRecordId'],
        'errorMessage': value['errorMessage'],
        'userTimezone': value['userTimezone'],
        'error': value['error'],
        'timezone_metadata': TimezoneMetadataToJSON(value['timezoneMetadata']),
    };
}

